<template>
  <div v-if="hasReferences" class="stock-invoice-references">
    <div v-if="sourceInvoice" class="stock-invoice-references__block mb-4">
      <v-subheader class="px-0">{{ $t("STOCK.INVOICES.SOURCE_INVOICE") }}</v-subheader>
      <p class="caption grey--text text--darken-1 mb-2">
        {{ $t("STOCK.INVOICES.SOURCE_INVOICE_HINT") }}
      </p>
      <router-link
        :to="{ name: 'stock-invoices-view', params: { id: sourceInvoice.id } }"
        class="stock-invoice-references__link"
      >
        <v-chip color="primary" outlined label class="ma-1">
          <v-icon left small>mdi-file-document-outline</v-icon>
          <span class="font-weight-medium">{{ displayCode(sourceInvoice) }}</span>
          <span v-if="sourceInvoice.type" class="ml-2 caption">
            {{ typeLabel(sourceInvoice.type) }}
          </span>
          <span v-if="sourceInvoice.status" class="ml-2 caption">
            · {{ statusLabel(sourceInvoice.status) }}
          </span>
        </v-chip>
      </router-link>
    </div>

    <div v-if="derivedInvoices.length" class="stock-invoice-references__block">
      <v-subheader class="px-0">{{ $t("STOCK.INVOICES.DERIVED_INVOICES") }}</v-subheader>
      <p class="caption grey--text text--darken-1 mb-2">
        {{ $t("STOCK.INVOICES.DERIVED_INVOICES_HINT") }}
      </p>
      <div class="d-flex flex-wrap">
        <router-link
          v-for="invoice in derivedInvoices"
          :key="invoice.id"
          :to="{ name: 'stock-invoices-view', params: { id: invoice.id } }"
          class="stock-invoice-references__link"
        >
          <v-chip
            :color="derivedChipColor(invoice.type)"
            outlined
            label
            class="ma-1"
          >
            <v-icon left small>{{ derivedIcon(invoice.type) }}</v-icon>
            <span class="font-weight-medium">{{ displayCode(invoice) }}</span>
            <span v-if="invoice.type" class="ml-2 caption">
              {{ typeLabel(invoice.type) }}
            </span>
            <span v-if="invoice.status" class="ml-2 caption">
              · {{ statusLabel(invoice.status) }}
            </span>
          </v-chip>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StockInvoiceReferencesPanel",
  props: {
    sourceInvoice: {
      type: Object,
      default: null,
    },
    derivedInvoices: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    hasReferences() {
      return !!this.sourceInvoice || (this.derivedInvoices || []).length > 0;
    },
  },
  methods: {
    displayCode(invoice) {
      if (!invoice) {
        return "-";
      }
      if (invoice.direction === "incoming") {
        return invoice.external_number || invoice.code || "-";
      }
      return invoice.fiscal_number || invoice.code || "-";
    },
    typeLabel(type) {
      const key = `STOCK.INVOICES.TYPES.${(type || "").toUpperCase()}`;
      return this.$te(key) ? this.$t(key) : type;
    },
    statusLabel(status) {
      const key = `STOCK.STATUSES.INVOICE.${(status || "").toUpperCase()}`;
      return this.$te(key) ? this.$t(key) : status;
    },
    derivedChipColor(type) {
      if (type === "credit_note") {
        return "info";
      }
      if (type === "debit_note") {
        return "warning";
      }
      return "primary";
    },
    derivedIcon(type) {
      if (type === "credit_note") {
        return "mdi-file-minus-outline";
      }
      if (type === "debit_note") {
        return "mdi-file-plus-outline";
      }
      return "mdi-file-document-outline";
    },
  },
};
</script>

<style scoped>
.stock-invoice-references__link {
  text-decoration: none;
}
.stock-invoice-references__link .v-chip {
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.stock-invoice-references__link .v-chip:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}
</style>
